export default {
    subtitle: "Les informations essentielles, au même endroit.",
    visit: "La réservation",
    visitHint: "Choisis la date, le nombre de couverts et l’horaire.",
    date: "Date de réservation",
    adults: "Adultes",
    children: "Enfants",
    guests: "Couverts",
    schedule: "Horaire",
    scheduleHint: "Les nombres indiquent les couverts déjà réservés.",
    chooseSlot: "Choisir un horaire",
    noSlots: "Aucun horaire disponible à cette date. Essaie une autre journée.",
    loadingSlots: "Chargement des horaires…",
    loadingContext: "Chargement des paramètres de l’établissement…",
    retry: "Réessayer",
    client: "Le client",
    clientHint: "Retrouve un client ou renseigne ses coordonnées.",
    searchClient: "Rechercher un client existant",
    searchPlaceholder: "Nom, prénom, téléphone ou email",
    searching: "Recherche en cours…",
    noClient: "Aucun client trouvé. Tu peux renseigner un nouveau client ci-dessous.",
    selectedClient: "Client existant sélectionné",
    changeClient: "Changer de client",
    clientUpdate: "Les modifications des coordonnées seront enregistrées sur sa fiche client.",
    contactMatch: "Une fiche client existe avec ces coordonnées.",
    dismissContactMatch: "Masquer le rappel",
    useContactMatch: "Utiliser la fiche de {name}",
    moreClient: "Informations complémentaires du client",
    clientCoordinates: "Coordonnées du client",
    newClient: "Renseigner un nouveau client",
    expandClient: "Afficher",
    collapseClient: "Replier",
    placement: "Placement et prestations",
    placementHint: "Tables, menus et options pour cette réservation.",
    placementPending: "Vérification du placement…",
    placementUnavailable: "Aucun placement automatique possible. Choisis une table ou indique que tu ignores le placement.",
    requestFailed: "La vérification n’a pas abouti. Réessaie pour obtenir une information à jour.",
    capacityPending: "Vérification de la capacité…",
    capacityAvailable: "Capacité vérifiée",
    summary: "Récapitulatif",
    details: "Détails et préférences",
    payment: "Confirmation et garantie",
    guaranteeHint: "La demande de garantie suit les paramètres de notification de l’établissement.",
    saveType: "Enregistrer comme",
    booking: "Réservation",
    option: "Option",
    waiting: "Liste d’attente",
    waitingFiles: "La liste d’attente ne prend pas en charge les pièces jointes. Retire les fichiers ou choisis une réservation pour les conserver.",
    save: "Créer la réservation",
    saveOption: "Enregistrer l’option",
    saveWaiting: "Ajouter à la liste d’attente",
    saving: "Enregistrement…",
    invalid: "Vérifie les champs indiqués avant d’enregistrer.",
    readyHint: "Sélectionne un horaire pour terminer la réservation.",
    extras: "Total des prestations",
    optional: "Facultatif",
    changeRestaurant: "Autre établissement",
    close: "Fermer le formulaire de réservation",
    discard: "Abandonner les informations saisies ?",
    keepEditing: "Continuer la saisie",
    discardConfirm: "Abandonner",
    tableCheck: "Vérification des tables",
    loadFailed: "Impossible de charger ces informations.",
    menusLoadFailed: "Impossible de charger les prestations de ce service.",
    generalOptionsLoadFailed: "Impossible de charger les options générales de ce service.",
    confirmationNeedsEmail: "Renseigne l’email du client pour lui envoyer une confirmation.",
    confirmationNeedsPhone: "Renseigne le téléphone du client pour lui envoyer une confirmation.",
    blockers: {
        loading: "Vérifications en cours…",
        loadFailed: "Certaines informations n’ont pas pu être chargées. Utilise « Réessayer » dans la section concernée.",
        slot: "Sélectionne un horaire pour créer la réservation.",
        guests: "Indique au moins un adulte.",
        waitingFiles: "Retire les pièces jointes pour ajouter le client à la liste d’attente.",
        tableUnavailable: "Une table sélectionnée n’est plus disponible. Modifie la sélection.",
        tableRequired: "Choisis une table ou coche « Ignorer le placement ».",
    },
    tables: {
        title: "Choisir les tables",
        hint: "Sélectionne une table ou un groupe dans la salle souhaitée.",
        table: "Table",
        group: "Groupe",
        seats: "places",
        selected: "Tables sélectionnées",
        chosen: "Dans la sélection",
        remove: "Retirer {table} · {room}",
        search: "Rechercher une table ou une salle",
        room: "Salle",
        allRooms: "Toutes les salles",
        noResults: "Aucune table ne correspond à ta recherche.",
        empty: "Aucune table configurée pour ce créneau.",
        unavailable: "Indisponible sur ce créneau",
        differentRoom: "Choisis dans la même salle",
        overlap: "Table déjà incluse dans la sélection",
        enoughSeats: "Nombre de places déjà couvert",
    },
};
